// import { useState, useEffect } from 'react';
// import { execSeatableSql } from './seatable.js';
import SectionHeader from './sectionheader.js';

function Clients(props) {
    /*
    const [data, setData] = useState(null);

    useEffect(() => {
      async function fetchData() {
        const sql = `SELECT fnMediaLink FROM SectionScrollingImage WHERE PageSection IN ('Clients') AND \`Capability\` IN ('${props.capability}') AND NOT isEmpty(fnMediaLink)`;
        setData(null);

        try {
          const rows = await execSeatableSql(sql);
          const rowData = rows && rows.results;
          setData(rowData.map(e => e.fnMediaLink));
        } catch (err) {
          // setError(err);
        }
      }
      fetchData();
    }, [props.capability]); 
    */
    return (
        <div id="Clients" className='nav-margin'>
            <SectionHeader capability={props.capability} section="Clients" wrapper="pb-5 border-bottom border-secondary" />
        </div>
    )
}

export default Clients;